import React from 'react';
/* eslint-disable max-len */

var ProfileIcon = function ProfileIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '32' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '32' : _ref$height;
  return React.createElement("svg", {
    width: width,
    height: height,
    viewBox: '0 0 32 32',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement("path", {
    d: 'M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z',
    fill: '#9CA3AF'
  }), React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M9.23199 20.0107C9.23199 17.3803 11.3643 15.248 13.9947 15.248H18.0053C20.6357 15.248 22.768 17.3803 22.768 20.0107V23.0187C22.768 23.434 22.4313 23.7707 22.016 23.7707H9.98399C9.56868 23.7707 9.23199 23.434 9.23199 23.0187V20.0107ZM13.9947 16.752C12.1949 16.752 10.736 18.2109 10.736 20.0107V22.2667H21.264V20.0107C21.264 18.2109 19.805 16.752 18.0053 16.752H13.9947Z',
    fill: 'white'
  }), React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M12.24 10.9867C12.24 8.91006 13.9234 7.22665 16 7.22665C18.0766 7.22665 19.76 8.91006 19.76 10.9867V11.9893C19.76 14.0659 18.0766 15.7493 16 15.7493C13.9234 15.7493 12.24 14.0659 12.24 11.9893V10.9867ZM16 8.73065C14.754 8.73065 13.744 9.7407 13.744 10.9867V11.9893C13.744 13.2353 14.754 14.2453 16 14.2453C17.2459 14.2453 18.256 13.2353 18.256 11.9893V10.9867C18.256 9.7407 17.2459 8.73065 16 8.73065Z',
    fill: 'white'
  }), React.createElement("path", {
    d: 'M17.0027 19.5093C17.0027 19.2324 17.2271 19.008 17.504 19.008H19.5093C19.7862 19.008 20.0107 19.2324 20.0107 19.5093C20.0107 19.7862 19.7862 20.0107 19.5093 20.0107H17.504C17.2271 20.0107 17.0027 19.7862 17.0027 19.5093Z',
    fill: 'white'
  }));
};

export { ProfileIcon as default };